import novinkyNaEmailEn from "../img/novinky-na-email_en.svg";
import { Fragment } from "react";

const NewsLetterContent = {
    en: {
        img: novinkyNaEmailEn,
        title: "In the old days, our messages were written on parchment and sent in bottles. Today it is much easier — leave your e-mail address and be the first to hear about the Captain's new expeditions and treasures.",
        placeholder: "Enter your e-mail address",
        buttonName: "Sign up",
        error: <Fragment>Dust and bullets, someone has already entered this email before you! <br />Enter another email, please.</Fragment>,
        emailExist: <Fragment>Dust and bullets, someone has already entered this email before you! <br />Enter another email, please.</Fragment>,
    },
    ka: {
        img: null,
        title: "ოდესღაც ჩვენი წერილები პერგამენტზე იწერებოდა და ბოთლებით იგზავნებოდა. დღეს კი ყველაფერი ბევრად მარტივია — უბრალოდ დატოვე შენი ელფოსტის მისამართი და პირველმა გაიგე კაპიტნის ახალი ექსპედიციებისა და საგანძურის შესახებ.",
        placeholder: "შეიყვანეთ თქვენი ელფოსტის მისამართი",
        buttonName: "რეგისტრაცია",
        error: <Fragment>მტვერი და ტყვიები, ეს ელფოსტა თქვენამდე უკვე ვიღაცამ შეიყვანა! <br />გთხოვთ, შეიყვანოთ სხვა ელფოსტის მისამართი.</Fragment>,
        emailExist: <Fragment>მტვერი და ტყვიები, ეს ელფოსტა თქვენამდე უკვე ვიღაცამ შეიყვანა! <br />გთხოვთ, შეიყვანოთ სხვა ელფოსტის მისამართი.</Fragment>,
    }
};
const NewsLetterContentFaq = {
    en: {
        img: novinkyNaEmailEn,
        title: "Up until a few years back, our messages would have been etched on parchment and sent out in bottles. Fortunately we have e-mail these days. Write your address on the sheet to be the first to find out about all the captain’s expeditions and treasures.",
        placeholder: "Enter your e-mail address",
        buttonName: "Sign up",
        error: <Fragment>Dust and bullets, someone has already entered this email before you! <br />Enter another email, please.</Fragment>,
        emailExist: <Fragment>Dust and bullets, someone has already entered this email before you! <br />Enter another email, please.</Fragment>,
    },
    ka: {
        img: null,
        title: "ოდესღაც ჩვენი წერილები პერგამენტზე იწერებოდა და ბოთლებით იგზავნებოდა. დღეს კი ყველაფერი ბევრად მარტივია — დატოვე შენი ელფოსტის მისამართი და პირველმა გაიგე კაპიტნის ახალი ექსპედიციებისა და საგანძურის შესახებ.",
        placeholder: "შეიყვანეთ თქვენი ელფოსტის მისამართი",
        buttonName: "რეგისტრაცია",
        error: <Fragment>მტვერი და ტყვიები, ეს ელფოსტა თქვენამდე უკვე ვიღაცამ შეიყვანა! <br />გთხოვთ, შეიყვანოთ სხვა ელფოსტის მისამართი.</Fragment>,
        emailExist: <Fragment>მტვერი და ტყვიები, ეს ელფოსტა თქვენამდე უკვე ვიღაცამ შეიყვანა! <br />გთხოვთ, შეიყვანოთ სხვა ელფოსტის მისამართი.</Fragment>,
    }
};

export {
    NewsLetterContent,
    NewsLetterContentFaq,
};
